<template>
  <v-app
      id="admin-view"
      dark>

    <core-toolbar />
    <core-drawer />

    <v-main>
        <router-view />
    </v-main>

  </v-app>
</template>

<script>
export default {
  name: 'AdminView',
  metaInfo () {
    return {
      title: 'Admin'
    }
  },
  mounted() {
    this.$store.state.app.section='admin';
  }
}

</script>

<style>

</style>
